export default __webpack_public_path__ + "static/media/logo.a8afc4bd.png";